<template>
  <Teleport :to="portalRootElementSelector">
    <ModalRoot
      v-model="isOpen"
      :prevent-close-on-backdrop-click="props.preventCloseOnBackdropClick"
      @close="close"
    >
      <template #body>
        <div
          v-bind="{
            ...$attrs,
            class: 'w-full',
          }"
        >
          <section
            class="relative m-auto bg-brand-strong-bg-overlay-80 backdrop-blur-3xl overflow-y-auto max-w-[345px] w-full h-full rounded-2xl sm:h-auto max-h-[calc(100vh_-_5em)] border border-basics-bgdivider-20"
            :class="$attrs.class"
          >
            <div
              class="flex flex-col p-4 gap-3 min-h-40 items-center justify-center text-center"
            >
              <slot></slot>
            </div>

            <div
              class="flex flex-row-reverse items-center justify-start p-4 gap-2.5 border-t border-basics-bgdivider-10 flex-wrap w-full"
            >
              <slot name="actions" :close="() => (isOpen = false)"></slot>
            </div>
          </section>
        </div>
      </template>
    </ModalRoot>
  </Teleport>
</template>

<script setup lang="ts">
const props = defineProps<{
  preventCloseOnBackdropClick?: boolean;
}>();

import ModalRoot from "@/components/ui/modal/modal-root.vue";
import { portalRootElementSelector } from "@/constants/ui";

const emit = defineEmits<{
  close: [];
}>();

const isOpen = defineModel<boolean>({ required: true });

const close = () => emit("close");
</script>
